import React from 'react';
import { Link } from 'react-router-dom';
import Error from '../../Components/UiErrorComponents/Error';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useGetAssignmentsQuery } from '../../features/assignment/assignmentApi';
import AssignmentSingleTableRow from './AssignmentSingleTableRow';

const Assignment = () => {
    const { data, isLoading, isError, isSuccess } = useGetAssignmentsQuery()
    let content = null
    if (isLoading) {
        content = <div className='center-of-window'>
            <Loading></Loading>
        </div>
    } else if (isError) {
        content = <Error error='Something went wrong!'>

        </Error>
    }
    else if (!data.length) {
        content = <div className='text-xl mt-5 text-center text-error'>
            No data found! Add Assignment
        </div>
    }
    else {
        content = <div className="overflow-x-auto mt-4">
            <table className="divide-y-1 text-base divide-gray-600 w-full">
                <thead>
                    <tr>
                        <th className="table-th">Title</th>
                        <th className="table-th">Video Title</th>
                        <th className="table-th">Mark</th>
                        <th className="table-th">Action</th>
                    </tr>
                </thead>

                <tbody className="divide-y divide-slate-600/50">
                    {
                        data.map(single => <AssignmentSingleTableRow key={single.id} data={single}></AssignmentSingleTableRow>)

                    }
                </tbody>
            </table>
        </div>
    }
    return (
        <>
            <section className="py-6 bg-primary">
                <div className="mx-auto max-w-full px-5 lg:px-20">
                    <div className="px-3 py-20 bg-opacity-10">
                        <div className="w-full flex">

                            <Link to='/admin/add-assignment' className="btn ml-auto">Add Assignment</Link>

                        </div>
                        {content}

                    </div>
                </div>
            </section>

        </>
    );
};

export default Assignment;